import { ui } from '../../styles/ui'

export default function Card({ variant = 'default', className = '', children, ...props }) {
  const variantClass = {
    default: ui.cards.default,
    compact: ui.cards.compact,
    highlighted: ui.cards.highlighted,
    warning: ui.cards.warning,
    danger: ui.cards.danger,
  }[variant] || ui.cards.default

  return (
    <section className={`${variantClass} p-6 ${className}`.trim()} {...props}>
      {children}
    </section>
  )
}
